import gql from 'graphql-tag';

const query = gql`
    query ($erasmusCode: String){
        managedByEWP (erasmusCode:$erasmusCode)
    }
`;
export { query };
